<template>
    <div class="charge">
        <div class="header">
            <el-row>
                <el-col :span="6">
                    <label class="headerlabel">内容名称</label>
                    <el-input v-model="param.contentName" placeholder="请输入内容名称" class="autowidth" clearable></el-input>
                </el-col>
                <el-col :span="6">
                    <label class="headerlabel">内容类型</label>
                    <el-select v-model="param.contentType" placeholder="请选择" class="autowidth" clearable >
                        <el-option label="量表" value="paper"></el-option>
                        <el-option label="课程" value="course"></el-option>
                        <el-option label="咨询" value="consul"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="6">
                    <label class="headerlabel">创建时间</label>
                    <el-date-picker
                    class="autowidth"
                    clearable
                    v-model="createTime"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd" 
                    format="yyyy-MM-dd">
                    </el-date-picker>
                </el-col>
                <el-col :span="6">
                    <el-button type="primary" @click="screen">筛选</el-button>
                    <el-button @click="reset">重置条件</el-button>
                </el-col>
            </el-row>
        </div>

        <main class="MainContent">
            <div style="margin: 0 0 20px;">
                <el-button type="primary" @click="dialogVisible=true">新增</el-button>
                <!-- <el-button style="margin-left: 20px;">导入</el-button> -->
            </div>
            <el-table
            :data="chargeData"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            style="width: 100%">
                <el-table-column prop="chargeId" label="ID" width="50"></el-table-column>
                <el-table-column prop="contentName" label="内容名称"></el-table-column>
                <el-table-column prop="realPrices" label="实际价格"></el-table-column>
                <el-table-column prop="underlinedPrice" label="划线价格"></el-table-column>
                <el-table-column label="内容类型" width="60">
                    <template slot-scope="scope">
                        <span v-if="scope.row.contentType=='paper'">量表</span>
                        <span v-else-if="scope.row.contentType=='course'">课程</span>
                        <span v-else-if="scope.row.contentType=='consul'">咨询</span>
                    </template>
                </el-table-column>
                <el-table-column prop="effectiveStartDate" label="生效时间"></el-table-column>
                <el-table-column prop="createTime" label="创建时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="Edit(scope.row)">修改</el-button>
                        <el-popconfirm title="是否确定删除？" @confirm="confirm(scope.row.chargeId)">
                            <el-button type="text" style="color: #F24B4E;margin-left: 10px;" slot="reference">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination
            :hide-on-single-page=true
            @current-change="handleinitialization"
            :current-page.sync="param.pageNum"
            :page-size="param.pageSize"
            layout="total, prev, pager, next"
            :total="param.PageTotal">
        </el-pagination>
        </main>

        <!-- 详情 -->
        <el-dialog
            title="服务价格配置"
            :visible.sync="dialogVisible"
            width="480px"
            center
            :before-close="handleClose">
            <div class="dialogcontent">
                <el-form style="padding: 0 40px;" label-width="80px">
                    <el-form-item label="内容编号">
                        <el-input type="text" v-model="AddParams.contentCode" disabled placeholder="请输入内容名称"  show-word-limit class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="内容名称">
                        <el-input type="text" v-model="AddParams.contentName" maxlength="30" placeholder="请输入内容名称"  show-word-limit class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="内容类型">
                        <el-select v-model="AddParams.contentType" placeholder="请选择" class="autowidth" clearable >
                            <el-option label="量表" value="paper"></el-option>
                            <el-option label="课程" value="course"></el-option>
                            <el-option label="咨询" value="consul"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="划线价格">
                        <el-input type="number" v-model="AddParams.underlinedPrice" min="0" placeholder="请输入划线价格"  class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="实际价格">
                        <el-input type="number" v-model="AddParams.realPrices" min="0" placeholder="请输入实际价格"  class="autowidth" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="生效时间">
                        <el-date-picker
                        class="autowidth"
                        clearable
                        v-model="assertTime"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd" 
                        format="yyyy-MM-dd"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-form>
                <div style="text-align: center;">
                    <el-button  @click="handleClose()">关闭</el-button>
                    <el-button type="primary" @click="save()">保存</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default{
    data() {
        return {
            loading:true,
            dialogVisible:false,
            createTime:[],
            assertTime:[],
            param:{
                pageNum:1,
                pageSize:10,
                PageTotal:0,
                contentName:'',
                contentType:'',
                params:{
                    startDate:'',
                    endDate:''
                }
            },
            contentCode:'',
            AddParams:{
                contentCode:"",//内容编号(通过合同管理获取编号接口获得)
                contentName: "",//内容名称
                contentType: "",//内容类型（paper:量表，course：课程，consul:咨询）
                realPrices: 1,//实际价格
                underlinedPrice: 1,//划线价格
                effectiveStartDate: "",//生效时间
                effectiveEndDate: ""//生效时间
            },
            chargeData: []
        }
    },
    watch:{
        createTime(newval){
            if(newval==null){
                this.param.params.startDate=''
                this.param.params.endDate=''
            }else{
                this.param.params.startDate=newval[0]
                this.param.params.endDate=newval[1]
            }
        },
        assertTime(newval){//生效时间
            if(newval==null){
                this.AddParams.effectiveStartDate='';
                this.AddParams.effectiveEndDate='';
            }else{
                this.AddParams.effectiveStartDate=newval[0];
                this.AddParams.effectiveEndDate=newval[1];
            }
        },
        'AddParams.realPrices'(newval,oldval){
            if(parseInt(this.AddParams.underlinedPrice)<parseInt(newval)){
                this.AddParams.realPrices=this.AddParams.underlinedPrice;
            }else if(parseInt(newval)<0){
                this.AddParams.realPrices=0;
            }
        },
        'AddParams.underlinedPrice'(newval,oldval){
            if(parseInt(newval)<0){
                this.AddParams.underlinedPrice=0;
            }
        }
    },
    mounted() {
        this.getCode();
        this.init();
    },
    methods: {
        // 获取合同编号
        getCode(){
            this.$Http_Post('/kg/contract/getCode',{model:'FEE'}).then(res=>{
                if(res.Code==0){
                    this.AddParams.contentCode=res.Data;
                    this.contentCode=res.Data;
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        init(){
            this.loading=true;
            this.isEdit=false;
            this.$Http_Post('/kg/charge/list',this.param).then(res=>{
                this.loading=false;
                if(res.Code==0){
                    this.chargeData=res.Data;
                    this.param.PageTotal=res.Counts;
                }else{
                    this.$message.error(res.Message);
                }
            });
        },
        screen(){
            this.param.pageNum=1;
            this.init();
        },
        handleinitialization(val){
            this.param.pageNum=val;
            this.init();
        },
        handleClose(){
            this.dialogVisible=false;
            this.AddParams=this.$options.data().AddParams;
            this.AddParams.contentCode=this.contentCode;
            this.assertTime=[];
            this.init();
        },
        reset(){
            this.param=this.$options.data().param;
            this.init();
        },
        // 保存
        save(){
            let Url=this.isEdit?'/kg/charge/edit':'kg/charge/add'
            this.$Http_Post(Url,this.AddParams).then(res=>{
                if(res.Code==0){
                    this.$message.success(res.Message);
                    this.dialogVisible=false;
                    this.handleClose();
                }else{
                    this.$message.error(res.Message);
                }
            })
        },
        Edit(e){
            this.dialogVisible=true;
            this.AddParams=e;
            this.assertTime=[e.effectiveStartDate,e.effectiveEndDate]
            this.isEdit=true;
        },
        // 删除记录
        confirm(id){
            this.$Http_Post('/kg/charge/remove/'+id).then(res=>{
                if(res.Code==0){
                    this.$message.success(res.Message);
                    this.param.pageNum=1;
                    this.init();
                }else{
                    this.$message.error(res.Message);
                }
            });
        }
    },
}
</script>
<style scoped>
.charge .header{background: #fff;padding: 20px;}
.charge .header .headerlabel{width:90px;display: inline-block;}
.charge .autowidth{width: 240px;}
.charge .MainContent{background: #fff;padding:20px 16px;margin:16px 0;}
</style>